var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.39982 0.832031C3.13612 0.832031 1.38466 2.81605 1.66544 5.06227L1.71834 5.4855C1.79576 6.10481 1.56954 6.7234 1.11087 7.14666C0.160413 8.02373 -0.103651 9.41969 0.460783 10.5833L0.529683 10.7254C1.0558 11.81 2.15533 12.4987 3.36082 12.4987H8.84136C9.88117 12.4987 10.8489 11.9675 11.4072 11.0903C12.1953 9.85197 11.9866 8.22751 10.911 7.22867L10.8818 7.2015C10.3894 6.74425 10.147 6.07811 10.2304 5.41137L10.2734 5.06675C10.5545 2.81815 8.8012 0.832031 6.5351 0.832031H5.39982ZM2.65772 4.93824C2.45155 3.28887 3.73762 1.83203 5.39982 1.83203H6.5351C8.1997 1.83203 9.48763 3.29097 9.28116 4.94272L9.23808 5.28734C9.11485 6.27319 9.47327 7.25816 10.2013 7.93425L10.2305 7.96142C10.9524 8.63185 11.0925 9.7222 10.5636 10.5533C10.1888 11.1421 9.53929 11.4987 8.84136 11.4987H3.36082C2.53843 11.4987 1.78833 11.0289 1.42942 10.2889L1.36052 10.1469C0.988467 9.37987 1.16253 8.4597 1.78903 7.88157C2.48487 7.23946 2.82806 6.301 2.71062 5.36147L2.65772 4.93824Z",
    fill: "#8B8B8B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5221 13.6987C4.35641 13.4778 4.04301 13.433 3.8221 13.5987C3.60119 13.7644 3.55641 14.0778 3.7221 14.2987L3.9221 14.5654C5.0221 16.032 7.2221 16.032 8.3221 14.5654L8.5221 14.2987C8.68779 14.0778 8.64301 13.7644 8.4221 13.5987C8.20119 13.433 7.88779 13.4778 7.7221 13.6987L7.5221 13.9654C6.8221 14.8987 5.4221 14.8987 4.7221 13.9654L4.5221 13.6987Z",
    fill: "#8B8B8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bell-icon.9beb88ec75a9a81f903021118ada3b63.svg";
export { ForwardRef as ReactComponent };